import { highlightsStateAtom } from '@/atoms';
import { useGroups } from '@/hooks';
import { getGroupType } from '@/utils';
import { Autocomplete, Stack, TextField } from '@mui/material';
import { useAtom } from 'jotai';
import { CurrentObjectivesCard } from './CurrentObjectivesCard';
import { DailyActivityCard } from './DailyActivityCard';
import { IncidentsByGradeCard } from './IncidentsByGradeCard';
// import { ObjectiveComplianceCard } from './ObjectiveComplianceCard';
import { ResponseTimeByHourCard } from './ResponseTimeByHourCard';
import { TotalIncidentsCard } from './TotalIncidentsCard';
import { UncheckedVehiclesCard } from './UncheckedVehiclesCard';

export function BasicCommandUnit() {
  const [{ basicCommandUnit }, setState] = useAtom(highlightsStateAtom);
  const groupType = getGroupType('BASIC_COMMAND_UNIT');
  const subgroupType = getGroupType('SECTOR');
  const {
    query: { data: groups },
  } = useGroups({
    types: [getGroupType(groupType)],
  });

  function handleBasicCommandUnitChange(event, value) {
    setState((state) => ({ ...state, basicCommandUnit: value }));
  }

  return (
    <Stack sx={{ p: 1 }} spacing={1}>
      <title>IR3 | Highlights | BCU</title>
      <Stack
        direction="row"
        sx={{ flexDirection: 'row-reverse', width: 1, pt: 0.5 }}
      >
        <Autocomplete
          size="small"
          value={basicCommandUnit}
          onChange={handleBasicCommandUnitChange}
          options={groups.map(({ code, name }) => ({
            value: code,
            label: name,
          }))}
          renderInput={(params) => <TextField label="BCU" {...params} />}
          isOptionEqualToValue={(option, value) =>
            (option.value ?? option) === (value.value ?? value)
          }
          renderOption={(props, option) => (
            <li {...props} key={option.value}>
              {option.label}
            </li>
          )}
          sx={{ minWidth: 200 }}
        />
      </Stack>
      <Stack spacing={1} direction="row" sx={{ alignItems: 'baseline' }}>
        <Stack spacing={1}>
          <CurrentObjectivesCard
            groupType={groupType}
            groupCode={basicCommandUnit?.value}
          />
          <TotalIncidentsCard
            groupType={groupType}
            groupCode={basicCommandUnit?.value}
            subgroupType={subgroupType}
          />
          {/* <ObjectiveComplianceCard
            groupType={groupType}
            groupCode={basicCommandUnit?.value}
          /> */}
          <UncheckedVehiclesCard groupCode={basicCommandUnit?.value} />
        </Stack>
        <Stack spacing={1} sx={{ flexGrow: 1 }}>
          <DailyActivityCard
            groupCode={basicCommandUnit?.value}
            subgroupType={subgroupType}
          />
          <IncidentsByGradeCard
            groupType={groupType}
            groupCode={basicCommandUnit?.value}
          />
          <ResponseTimeByHourCard
            groupType={groupType}
            groupCode={basicCommandUnit?.value}
            subgroupType={subgroupType}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
